export function processApplicationData(inventory) {
  const processedData = { inventory };

  eachRecursive(processedData.inventory);

  return processedData;
}

export function eachRecursive(obj) {
  Object.keys(obj).forEach((key) => {
    if (key === "id") {
      obj.id = 0;
    }
    if (typeof obj[key] === "object" && obj[key] !== null) {
      eachRecursive(obj[key]);
    }
  });
}

function sortScalesByStartAndEnd(scalesArray) {
  scalesArray.sort((firstScale, secondScale) => {
    if (firstScale.start !== secondScale.start) {
      return firstScale.start - secondScale.start;
    }
    return firstScale.end - secondScale.end;
  });
}

function sortNestedScalesObjects(obj) {
  const scalesPaths = ["scales", "scope.scales", "scope.subScope.subScales"];

  scalesPaths.forEach((path) => {
    let scalesLocation = obj;
    path.split(".").forEach((part) => {
      scalesLocation = scalesLocation && scalesLocation[part];
    });

    if (Array.isArray(scalesLocation)) {
      sortScalesByStartAndEnd(scalesLocation);
    }
  });

  return obj;
}
